import React from 'react'
import { StatusTracker, StatusTrackerStep } from '@apex/component-library'
import { PublicStatus, PublicStatusDisplay } from '../../../../api/types'

export interface StatusTrackerProps {
  currentStatus: PublicStatus
}

type VisibleStep = Exclude<
  PublicStatus,
  PublicStatus.Error | PublicStatus.Rejected
>
type StepsType = Array<VisibleStep>

const steps: StepsType = [
  PublicStatus.New,
  PublicStatus.SentToDeliveringFirm,
  PublicStatus.ResponseReceived,
  PublicStatus.Approved,
  PublicStatus.Complete,
]

export enum StatusValues {
  Incomplete = 'incomplete',
  Complete = 'complete',
  Current = 'current',
}

export const getStepValue = (
  stepIndex: number,
  currentStatus: PublicStatus
) => {
  // this typecasting is because TypeScript doesn't allow .indexOf and .includes to fail
  // and currentStatus could include strings that are not in our StepType
  const currentStatusIndex = (steps as PublicStatus[]).indexOf(currentStatus)
  if (stepIndex < currentStatusIndex) {
    return StatusValues.Complete
  }
  if (stepIndex === currentStatusIndex) {
    return StatusValues.Current
  }
  return StatusValues.Incomplete
}

const StatusTrackerWrapper = ({ currentStatus }: StatusTrackerProps) => (
  <StatusTracker>
    {steps.map((step, idx) => {
      return (
        <StatusTrackerStep
          label={PublicStatusDisplay[step]}
          status={getStepValue(idx, currentStatus)}
          key={step}
        />
      )
    })}
  </StatusTracker>
)

export default StatusTrackerWrapper
